import { Form, Spin, Input, Button } from 'antd';
import { StyledCreateAndEnrollStudentStep } from './CreateAndEnrollStudentStep.styled';
import useCreateAndEnrollStudentStep from './useCreateAndEnrollStudentStep.hook';
import { Paragraph, Title } from '@/shared/Typography';

export default function CreateAndEnrollStudentStep({ flowState, flowActions }) {
  const { state, actions } = useCreateAndEnrollStudentStep({
    flowState,
    flowActions,
  });

  return (
    <StyledCreateAndEnrollStudentStep>
      <Spin spinning={state.loading}>
        <div className="centered-form">
          <Paragraph className="bigger-text">
            Please type your FIRST and LAST NAME and a PASSWORD to create your
            new user:
          </Paragraph>
          <Form
            onFieldsChange={actions.handleFormChange}
            initialValues={{}}
            layout="vertical"
            onFinish={actions.createAndEnrollStudent}
          >
            <Form.Item
              name="firstName"
              rules={[
                {
                  required: true,
                  message: 'Please write your first name',
                },
                {
                  validator: validateName,
                },
              ]}
            >
              <Input
                spellCheck={false}
                placeholder="Type your first name"
                autoComplete="one-time-code"
              />
            </Form.Item>
            <Form.Item
              name="lastName"
              rules={[
                {
                  required: true,
                  message: 'Please write your last name',
                },
                {
                  validator: validateName,
                },
              ]}
            >
              <Input
                spellCheck={false}
                placeholder="Type your last name"
                autoComplete="one-time-code"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  min: 4,
                  required: true,
                  message:
                    'Please write a password (at least 4 letters and/or numbers)',
                },
                {
                  validator: async (_, value) => {
                    if (value && value.length > 0 && value.includes(' ')) {
                      return Promise.reject(
                        new Error('The password cannot contain blank spaces')
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input.Password
                placeholder="Write a Password."
                autoComplete="one-time-code"
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              dependencies={['password']}
              rules={[
                {
                  requierd: true,
                  message: 'Please confirm your password!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        'The two passwords that you entered do not match!'
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="Repeat the same password to confirm it."
                autoComplete="one-time-code"
              />
            </Form.Item>

            <Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                size="large"
                block
                loading={state.loading}
                disabled={!state.isFormValid}
              >
                Continue
              </Button>
            </Form.Item>
          </Form>{' '}
        </div>
      </Spin>
    </StyledCreateAndEnrollStudentStep>
  );
}

const invalidCharacters = /[^a-zA-ZÀ-ÿ\s]/;

const validateName = (_, value) => {
  if (value && invalidCharacters.test(value)) {
    const invalidChar = value.match(invalidCharacters)[0];
    return Promise.reject(new Error(`${invalidChar} is not a valid character`));
  }
  return Promise.resolve();
};
